export default {
  tutor_earnings: state => state.earnings,
  dashboard_earnings: state => state.dashboard_earnings,
};



// WEBPACK FOOTER //
// ./src/store/earnings/getters.js